import React from 'react';

interface ServiceCardProps {
  title: string;
  description: React.ReactNode;
  icon: React.ReactNode;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ title, description, icon }) => {
  return (
    <div className="bg-blue-50 p-5 sm:p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow border-t-4 border-blue-600">
      <div className="text-primary mb-3 sm:mb-4">
        {icon}
      </div>
      <h3 className="text-lg sm:text-xl font-bold mb-2 text-blue-800">{title}</h3>
      <p className="text-blue-700 text-sm sm:text-base">{description}</p>
    </div>
  );
};

export default ServiceCard;